import { Donuz } from "donuz-js/Donuz";
import Loading from "@/components/Loading.vue";

// @ is an alias to /src
export default {
    name: "redeemption",
    components: {
        Loading
    },
    data() {
        return {
            obj: {},
            gifts: {},
            loading: true,
            client: {}
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        let result = await Donuz.gifts.getGifts(
            sessionStorage.getItem(btoa("tokenCliente"))
        );
        if (result.status == 200) {
            this.gifts = result.presentes;
        }
        this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
        this.loading = false
    },
    methods: {}
};